import { createQueryKeys } from '@lukemorales/query-key-factory';

export const aaForms = createQueryKeys('aaForms', {
  list: (agentProfileId: string | null) => [agentProfileId ?? 'mine'],
  detail: (id: string) => [id],
  access: (agentProfileId: string | null, dealId: string | null) => [agentProfileId ?? 'self', dealId ?? 'none'],
  agents: (q: string) => [q],
  sign: (token: string) => [token],
});
